import { FC } from "react";
import { Alert, AlertProps } from "@/components-v2/Alert";
import { Box } from "@/components-v2/Box";
import { LinkButton } from "@/components-v2/Button";
import { DCEvent } from "@/events/eventsDomain";
import { TMessage } from "@/i18n/tt";
import { useTranslation } from "@/stores/RootStoreContext";
import { Markdown } from "@/text/Markdown";

type PerDateFilterAlertProps = {
  date: string;
  message?: TMessage;
  action?: { label: TMessage; onClick: DCEvent[] };
  onReset: () => void;
  marginTop?: AlertProps["marginTop"];
  vertical?: boolean;
};

export const PerDateFilterAlert: FC<PerDateFilterAlertProps> = ({
  date,
  message,
  action,
  onReset,
  marginTop,
  vertical = false,
}) => {
  const { t } = useTranslation();

  return (
    <Alert
      type={"warning"}
      marginTop={marginTop}
      message={
        <Box vertical={vertical} className={"w-full"} alignItems={vertical ? "stretch" : "center"}>
          <Box className={vertical ? "w-full" : "flex-1 min-w-0"} textAlign={"left"}>
            <Markdown
              disableLastMargin
              value={t(
                message ?? {
                  key: "shareholders.filter.per-date.applied",
                  params: { date: { type: "date", value: date } },
                },
              )}
            />
          </Box>
          <Box className={vertical ? "w-full" : undefined} justifyContent={"end"} gap={"lg"}>
            {action && (
              <LinkButton
                color={"inherit"}
                arrow={"right"}
                label={action.label}
                onClick={action.onClick}
              />
            )}
            <LinkButton
              color={"inherit"}
              icon={"arrow-counter-clockwise"}
              label={{ key: "shareholders.filter.per-date.reset" }}
              onClick={onReset}
            />
          </Box>
        </Box>
      }
    />
  );
};
